import { ArrowDown, ArrowDownLeft, ArrowDownRight, ArrowLeft, ArrowRight, ArrowUp, ArrowUpLeft, ArrowUpRight } from 'lucide-react';

type TDirection = keyof typeof directions;
type SVGProps = React.SVGAttributes<SVGSVGElement>;

const directions = {
  up: (props: any) => <ArrowUp className="w-4 h-4" {...props} />,
  down: (props: any) => <ArrowDown className="w-4 h-4" {...props} />,
  left: (props: any) => <ArrowLeft className="w-4 h-4" {...props} />,
  right: (props: any) => <ArrowRight className="w-4 h-4" {...props} />,
  'up-right': (props: any) => <ArrowUpRight className="w-4 h-4" {...props} />,
  'up-left': (props: any) => <ArrowUpLeft className="w-4 h-4" {...props} />,
  'down-right': (props: any) => <ArrowDownRight className="w-4 h-4" {...props} />,
  'down-left': (props: any) => <ArrowDownLeft className="w-4 h-4" {...props} />,
  null: () => null,
};

const directionLabels = {
  up: 'Upp',
  down: 'Ner',
  left: 'Vänster',
  right: 'Höger',
  'up-right': 'Upp höger',
  'up-left': 'Upp vänster',
  'down-right': 'Ner höger',
  'down-left': 'Ner vänster',
  null: 'Ingen pil',
};

const ElevatorIcon = (props: SVGProps) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <rect x="3" y="2" width="18" height="20" rx="2" />
    <line x1="12" y1="4" x2="12" y2="20" />
    <polyline points="5.5,12 7.5,8 9.5,12" />
    <polyline points="14.5,12 16.5,16 18.5,12" />
  </svg>
);

const StairsIcon = (props: SVGProps) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <polyline points="3,21 8,21 8,16 13,16 13,11 18,11 18,6 21,6" />
  </svg>
);

const Direction = ({
  direction,
  ...rest
}: { direction: keyof typeof directions } & SVGProps & {
    size?: string;
  }) => {
  const Component = directions[direction];
  return <Component {...rest} />;
};

export type { TDirection };
export { directions, Direction, directionLabels, ElevatorIcon, StairsIcon };
